export function checkDocsUrl(check) {
    let splitName = check.split(".");
    let component = splitName[0];
    let checkName = splitName[1].replace("check_", "");
    return `https://developer.atlassian.com/platform/service-linter/catalog/${component}#${checkName}`;
}
